export { ComunidadeIuppService } from './ComunidadeIuup'



// WEBPACK FOOTER //
// ./src/features/Services/ComunidadeIupp/index.js